export enum HeraldCategoryType {
    RiskValues = 'risk_values',
    CoverageValues = 'coverage_values',
}
